import type { QueryStatus } from "@tanstack/react-query";
import { translate } from "app/filters/i18nFilter";
import type { SignalEventType } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/types";
import { LeftFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import type SignalEventsTooltipViewModel from "../../../models/view/signals-tooltip/SignalEventsTooltipViewModel";
import SignalsListLoader from "../../shared/SignalsListLoader/SignalsListLoader";
import SignalsTooltipButtonLink from "../shared/SignalsTooltipButtonLink/SignalsTooltipButtonLink";
import { LOADER_ITEM_COUNT } from "../shared/SignalsTooltipContent/const";
import SignalsTooltipContent from "../shared/SignalsTooltipContent/SignalsTooltipContent";
import SignalsEventsList from "./SignalsEventsList/SignalsEventsList";

type Props = {
    state: QueryStatus;
    redirectLink: URL["href"];
    createViewModel(eventsLimit: number): Readonly<SignalEventsTooltipViewModel>;
    getSignalTypeLink(eventType: SignalEventType): URL["href"];
    onViewAll(): void;
    onSignalTypeClick(signalType: SignalEventType): void;
    onSignalArticleClick(signalType: SignalEventType, articleTitle: string): void;
};

const SignalsEventsTooltipContent = (props: Props) => {
    const {
        state,
        redirectLink,
        getSignalTypeLink,
        createViewModel,
        onViewAll,
        onSignalTypeClick,
        onSignalArticleClick,
    } = props;

    const renderContent = (state: QueryStatus) => {
        switch (state) {
            case "success":
                return (
                    <SignalsEventsList
                        createViewModel={createViewModel}
                        getSignalTypeLink={getSignalTypeLink}
                        onSignalTypeClick={onSignalTypeClick}
                        onSignalArticleClick={onSignalArticleClick}
                    />
                );
            case "error":
                return <LeftFlexRow>{translate("si.signals.table-columns.tooltip.error.data-load")}</LeftFlexRow>;

            case "pending":
            default:
                return <SignalsListLoader itemsCount={LOADER_ITEM_COUNT} />;
        }
    };

    return (
        <SignalsTooltipContent
            title={translate("si.signals.table-columns.tooltip.title")}
            footer={
                <SignalsTooltipButtonLink
                    text={translate("si.signals.table-columns.tooltip.view-all.signals")}
                    redirectLink={redirectLink}
                    withPointerEvents={state === "success"}
                    onClick={onViewAll}
                />
            }
        >
            {renderContent(state)}
        </SignalsTooltipContent>
    );
};

export default SignalsEventsTooltipContent;
